import "./OverdueTaskCount.css";

import { useAuth } from "../../../../../useAuth";

type OverdueTasksVariant = "default" | "dashboard";
export interface OverdueTaskProps {
  amount: string;
  label: string;
  variant?: OverdueTasksVariant;
}

export const OverdueTask = ({ amount, label, variant = "default" }: OverdueTaskProps): JSX.Element => {
  const { currentUserType } = useAuth();
  switch (variant) {
    case "dashboard":
      return (
        <div className="OverdueTaskDashboard">
          <p className="body1">{label}</p>
          <h1 className={`OverdueAmount ${currentUserType}`}>{amount}</h1>
        </div>
      );
    default:
      return (
        <div className="OverdueTask">
          <h1 className={`OverdueAmount ${currentUserType}`}>{amount}</h1>
          <p className="body2Light">{label}</p>
        </div>
      );
  }
};
